import Router from '@/router';
import Store from '@/store';
import App from '@/utils/app';
import { IrstoreTracker as IrTrack } from '@/utils/tracker';
import { proxyNavigateTo as NavigateTo } from '@/utils/navigateTo';
import i18n, { EN, ZH_HK } from '@/assets/js/i18n';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

import {
	getUserInfo,
	getVersionCompared,
	isApp,
	getUrlParam,
	getFileViewerUrl,
	isWxMiniProgram,
	formatDefault,
	isNonValue,
	debounce
} from '@/utils/api';

const getRoute = () => Router.currentRoute;

const irTrackSend = (title, id, defaultType = true, otherParams) => {
	IrTrack.send({
		curPage: '投资者关系专栏',
		content: '查看详情',
		event: 'CLICK',
		module: '投资者关系专栏',
		params: {
			'点击内容名称': title,
			// PS: 只有几个投关活动类型里面的页面跳转，才属于默认内容
			'点击内容类型': defaultType ? '默认内容' : '自定义添加内容',
			'内容ID': id,
			'企业ID': resolveStoreId(),
			'页面ID': resolvePageId(),
			...otherParams
		}
	});
};

export const handleCoreToRoadshow = obj => {
	// 声明 search 保存 路由 额外参数
	let search = '';
	if (obj.optional) {
		for (let key in obj.optional) {
			if (obj.optional[key] === undefined || obj.optional[key] === null || obj.optional[key] === '') {
				continue;
			}

			search += `&${key}=${obj.optional[key]}`;
		}
	}
	let query = {
		id: obj.id,
		comein_channel: getUrlParam().comein_channel,
		lang: i18n.locale
	};

	Object.assign(query, obj.optional);

	let userInfo = getUserInfo() || {};

	// 区别App和H5跳转
	// 路演
	if (!Number(obj.ct) || obj.ct === undefined) {
		const UILoaded = 82218;
		const UIScrolled = 2;
		const UIGlobal = 106;

		Object.assign(query, {
			UILoaded,
			UIScrolled,
			UIGlobal
		});

		if (isApp) {
			// 兼容旧版本 路演 跳转
			if (userInfo.version && getVersionCompared(userInfo.version, '3.4.0') < 0) {
				App.goRoom({ rid: obj.id, meta: null });
			} else {
				if (Number(obj.inner)) {
					const url = `${location.origin}/mobile/roadshow/home${objectToQueryString(query)}`;
					location.replace(url);
				} else {
					let jump_url = `${location.origin}/mobile/roadshow/home?UILoaded=${UILoaded}&UIScrolled=${UIScrolled}&UIGlobal=${UIGlobal}&id=${obj.id}${search}`;
					if (Number(obj.replace)) {
						location.replace(jump_url);
					} else {
						App.openURL({ url: jump_url });
					}
				}
			}
		} else {
			const url = `${location.origin}/mobile/roadshow/home${objectToQueryString(query)}`;
			if (obj.replace) {
				location.replace(url);
			} else {
				NavigateTo({
					path: url
				});
			}
		}
	} else {
		const UILoaded = 378;
		const UIGlobal = 106;
		const UIScrolled = 378;

		Object.assign(query, {
			UILoaded,
			UIScrolled,
			UIGlobal
		});

		if (isApp) {
			// 兼容旧版本 回放 跳转
			if (getVersionCompared(userInfo.version, '3.4.0') < 0) {
				App.goPlayback({ pid: obj.id });
			} else {
				if (Number(obj.inner)) {
					const url = `${location.origin}/mobile/roadshow/record${objectToQueryString(query)}`;
					location.replace(url);
				} else {
					let jump_url = `${location.origin}/mobile/roadshow/record?UILoaded=${UILoaded}&UIScrolled=${UIScrolled}&UIGlobal=${UIGlobal}&id=${obj.id}${search}`;
					if (Number(obj.replace)) {
						location.replace(jump_url);
					} else {
						App.openURL({ url: jump_url });
					}
				}
			}
		} else {
			const url = `${location.origin}/mobile/roadshow/record${objectToQueryString(query)}`;
			if (obj.replace) {
				location.replace(url);
			} else {
				NavigateTo({
					path: url
				});
			}
		}
	}
};
/**
 * 	公开状态openstatus
 *  0: 私密
 *	1: 公开
 *	2: 专场（包含机构和专场活动）
 *	3: 私募
 *	4: 课程
 *	5: 开户分仓
 *	6: 实名认证
 *	7: 申请参会
 *	8: 投资调研
 *	9: 专栏路演
 *	10: 付费路演
 *	12: 会员
 * @param { Object } obj
 * @property { String } obj.id 路演id
 * @property { Object } obj.optional 额外参数
 * @property { String } obj.openStatus 路演状态
 * @property { Number } obj.ct 0/undefined: 路演；1：回放
 * @property { Boolean } obj.replace 是否替换当前页面
 * @property {} obj.checkUserAsset
 * @property {} obj.inner APP内部跳转 是否采用 内部跳转的方式
 * @property {} obj.sourceType
 * @property {} obj.descUrl
 *
 */
export const jumpToRoadshow = debounceAndSafeExecute(function (obj) {
	if (obj.sourceType == 1) {
		irTrackSend('投关活动', obj.id, false);
		//用户自主添加
		return NavigateTo({
			path: obj.descUrl
		});
	}
	irTrackSend('投关活动', obj.id);
	handleCoreToRoadshow(obj);
});

export const handleCoreToOffline = obj => {
	let comein_channel = getUrlParam().comein_channel ? `&comein_channel=${getUrlParam().comein_channel}` : '';
	const url = `${location.origin}/mobile/enrollment/detail?id=${obj.id}${comein_channel}&UIGlobal=66&lang=${i18n.locale}`;
	return NavigateTo({
		path: url
	});
};
export const jumpToEnrollmentDetail = debounceAndSafeExecute(function (obj) {
	if (obj && obj.sourceType == 1) {
		irTrackSend('投关活动', obj.id, false);
		//用户自主添加
		return NavigateTo({
			path: obj.descUrl
		});
	}
	irTrackSend('投关活动', obj.id);
	handleCoreToOffline(obj);
});

export const handleCoreToResearch = item => {
	if (!item.url) {
		return Store.dispatch('showTooltip', {
			msg: '暂无活动文件'
		});
	}
	return NavigateTo({
		file: getFileViewerUrl(item.url, item.title),
		title: item.title,
		minPath: item.url
	});
};
export const jumpToLogDetail = debounceAndSafeExecute(function (item) {
	irTrackSend('投关活动', item.id, false);
	handleCoreToResearch(item);
});

export const jumpToNews = debounceAndSafeExecute(function (item, callback) {
	irTrackSend('新闻资讯', item.id, false);
	const route = getRoute();

	if (item.url && item.content) {
		// 来源为微信公众号时, 直接跳转源链接
		const isWxSource = item.sourceType && item.sourceType == 3;
		if (isWxSource) {
			return NavigateTo({ path: item.url });
		}
		// 小程序访问->跳转IRM页面
		if (isWxMiniProgram) {
			if (callback) {
				callback();
				return;
			}
			return NavigateTo({
				name: 'enterprise_new_detail',
				query: { storeId: route.query.storeId, newId: item.id }
			});
		}
		// 否则，H5&APP跳转源链接
		return NavigateTo({ path: item.url });
	}

	// 2. 新闻仅包含源链接
	if (item.url) {
		return NavigateTo({ path: item.url });
	}

	// 3. 新闻仅包含富文本
	if (item.content) {
		if (callback) {
			callback();
			return;
		}
		return NavigateTo({
			name: 'enterprise_new_detail',
			query: { storeId: route.query.storeId, newId: item.id }
		});
	}
});

const formComein = link => {
	if (!link) return false;
	return link.indexOf('.comein.cn') === -1;
};
export const jumpToAnnouncement = debounceAndSafeExecute(async function (item) {
	irTrackSend('公司公告', item.id, false);
	const realLink = item.comeinLink || item.sourceLink;
	if (!realLink) {
		return Store.dispatch('showDialog', {
			dialog_alert: true,
			dialog_text: '该文件地址失效，暂不支持打开',
			dialog_alert_data: [
				{
					btn: '知道了',
					callback: () => {
						Store.dispatch('hideDialog');
					}
				}
			]
		});
	}
	announcementCoreJump(realLink, item.id + item.title, item.type);
});
export const announcementCoreJump = debounceAndSafeExecute(async function (url, title = '', type = '') {
	const unValidLink = formComein(url);
	if (unValidLink && isWxMiniProgram) {
		// TODO vue2.7 原型链这里拿不到 需要换到页面去处理
		// vue.$copyText(url).then(
		// 	e => {
		// 		Store.dispatch('showTooltip', {
		// 			msg: '小程序禁止访问，已复制链接至粘贴板，可粘贴链接至浏览器查看',
		// 			time: 2000
		// 		});
		// 	},
		// 	e => {
		// 		Store.dispatch('showTooltip', {
		// 			msg: '访问失败',
		// 			time: 2000
		// 		});
		// 	}
		// );
		return;
	}
	if (type == 'custom') {
		return NavigateTo({ path: url });
	}
	NavigateTo({
		file: getFileViewerUrl(url, title),
		title: title
	});
});

export const jumpToESG = debounceAndSafeExecute(function (item) {
	irTrackSend('esg', item.id, false);

	const file = item.url || item.fileUrl;
	if (!file) return;

	let obj = {
		file: getFileViewerUrl(file, item.subject),
		title: item.subject
	};
	NavigateTo(obj);
});

export const jumpToGovernance = debounceAndSafeExecute(function (item) {
	irTrackSend('企业管治', item.id, false);

	const file = item.url || item.fileUrl;
	if (!file) return;

	let obj = {
		file: getFileViewerUrl(file, item.subject),
		title: item.subject
	};
	NavigateTo(obj);
});

export const jumpToReport = debounceAndSafeExecute(function (item) {
	irTrackSend('券商研报', item.id, false);

	let obj = !item.url
		? {
			name: 'enterprise_report_detail',
			query: {
				reportId: item.reportId,
				reportType: item.type
			}
		}
		: {
			file: getFileViewerUrl(item.url, item.title),
			title: item.title
		};
	NavigateTo(obj);
});

export const jumpToCustom = debounceAndSafeExecute(function (item, name) {
	irTrackSend(name, item.id, false);

	if (item.type == 2) {
		return NavigateTo({
			path: item.url
		});
	}
	customFileCoreJump(item.fileUrl, item.fileName);
});
export const customFileCoreJump = debounceAndSafeExecute(function (url, title = '') {
	if (!url) {
		return Store.dispatch('showTooltip', {
			msg: '暂无活动文件'
		});
	}
	NavigateTo({
		file: getFileViewerUrl(url, title)
	});
});

export const jumpToDisplayFile = debounceAndSafeExecute(function (item) {
	if (!item.skipUrl) return;
	irTrackSend('展示模块', null, false, {
		'模块名称': item.name,
		'模块ID': item.moduleId
	});

	let options;
	if (item.skipType === 1) {
		options = {
			file: getFileViewerUrl(item.skipUrl, item.name)
		};
	} else {
		options = {
			path: item.skipUrl
		};
	}
	NavigateTo(options);
});

export const handleCoreToCompany = (option, isOwn) => {
	if (isOwn) {
		const { data } = option;
		if (!data) return;
		const _url = data.url;
		if (!_url) return;

		let createUrl = new URL(_url);
		if (!isApp && createUrl.hostname == 'www.ctfo.com') {
			//千方科技网址重定向有问题，需要特殊处理
			let link = document.createElement('a');
			link.href = _url;
			link.rel = 'noreferrer';
			document.body.appendChild(link);
			link.click();
			return;
		}

		let transferUrl = _url;
		if (isWxMiniProgram) {
			// 小程序端 井号拼接内容会导致页面错误 所以这里裁剪掉
			transferUrl = transferUrl.split('#')[0];
		}
		NavigateTo({
			path: _url
		});
	} else {
		const { module } = option;

		let transferUrl = module.url;
		if (isWxMiniProgram) {
			transferUrl = transferUrl.split('#')[0];
		}
		NavigateTo({
			path: transferUrl
		});
	}
};
export const jumpToCompany = debounceAndSafeExecute(function (option, isOwn) {
	irTrackSend('企业介绍', null, false);
	handleCoreToCompany(option, isOwn);
});

export const handleBannerJump = debounceAndSafeExecute(function (item) {
	if (!item.url) return;
	if (item.type == 'VIDEO') return;

	IrTrack.send({
		curPage: '投资者关系专栏',
		content: '查看详情',
		event: 'CLICK',
		module: '投资者关系专栏',
		params: {
			'点击内容名称': '运营卡片',
			'点击内容类型': '自定义添加内容',
			'内容ID': item.id,
			'企业ID': resolveStoreId(),
			'页面ID': resolvePageId()
		}
	});

	if (item.type == 'DOCUMENT') {
		NavigateTo({
			file: getFileViewerUrl(item.url, item.title),
			title: item.title
		});
	} else {
		NavigateTo({
			path: item.url
		});
	}
});

function safeExecute(callback, ...args) {
	try {
		return callback(...args);
	} catch (error) {
		console.error('An error occurred:', error);
	}
}
function debounceAndSafeExecute(callback, delay = 220) {
	const debouncedCallback = debounce(function (...args) {
		return safeExecute(callback, ...args);
	}, delay);
	return (...args) => debouncedCallback(...args);
}

function objectToQueryString(obj) {
	// 使用Array.from将对象的键值对转换为数组
	const entries = Array.from(Object.entries(obj));

	// 使用reduce将键值对数组转换为查询字符串，注意处理第一个元素不需要"&"前缀
	return entries.reduce((query, [key, value], index) => {
		// 对值进行encodeURIComponent编码，以确保特殊字符正确处理
		const encodedValue = encodeURIComponent(value);

		// 首个元素使用"?"，后续元素使用"&"
		const separator = index === 0 ? '?' : '&';

		// 将当前键值对与已有的查询字符串拼接
		query += `${separator}${encodeURIComponent(key)}=${encodedValue}`;

		return query;
	}, '');
}

/**
 * @param {number} amount - 需要转换的数字
 * @return {string} - 转换后的字符串
 */
export const convertNumberToUnit = amount => {
	const positive = amount > 0 ? 1 : -1;
	amount = Math.abs(amount);

	// 定义单位和对应的值
	const units = [
		{ name: '万亿', value: 1e12 },
		{ name: '亿', value: 1e8 },
		{ name: '万', value: 1e4 }
	];

	const enUnits = [
		{ name: 'B', value: 1e9 },
		{ name: 'M', value: 1e6 },
		{ name: 'K', value: 1e3 }
	];

	const hkUnits = [
		{ name: '萬億', value: 1e12 },
		{ name: '億', value: 1e8 },
		{ name: '萬', value: 1e4 }
	];

	const selectedUnits = i18n.locale === EN ? enUnits : i18n.locale === ZH_HK ? hkUnits : units;

	// 遍历单位，找到合适的单位进行转换
	for (let unit of selectedUnits) {
		if (amount >= unit.value) {
			return [((positive * amount) / unit.value).toFixed(2), unit.name];
		}
	}

	// 如果没有合适的单位，直接返回原值
	return [(positive * amount).toFixed(2), ''];
};
export const formatterColTransferUnit = (value, split = false) => {
	const nonValue = isNonValue(value);
	if (nonValue) return formatDefault(value);

	const [v, u] = convertNumberToUnit(value);

	if (split) return [v, u];
	return `${v}${u}`;
};

export const toThousandSeparator = num => {
	const value = Number(num).toLocaleString();
	return formatDecimal(value);
};
export const formatterColTransferThousand = value => {
	const nonValue = isNonValue(value);
	if (nonValue) return formatDefault(value);
	return toThousandSeparator(value);
};
export const formatDecimal = inputString => {
	// 判断字符串中是否包含小数点
	if (inputString.includes('.')) {
		// 分割小数点前后的部分
		const [integerPart, decimalPart] = inputString.split('.');

		// 补零，确保小数点后至少有两位数
		let formattedDecimal = decimalPart;
		if (formattedDecimal.length === 1) {
			formattedDecimal += '0';
		}

		// 拼接整数部分和格式化后的小数部分
		return `${integerPart}.${formattedDecimal}`;
	} else {
		// 不包含小数点，直接返回原字符串
		return inputString;
	}
};

/** 四舍五入保留至小数点后两位 */
export const roundToTwoDecimals = num => {
	if (isNonValue(num)) return '-';
	return `${parseFloat(num.toFixed(2))}%`;
};

export const formatPercentage = (value, unit = '%') => {
	if (isNonValue(value)) return '-';
	return `${value}${unit}`;
};
